module.exports = __webpack_public_path__ + "static/media/button-logout-btn.bb253127.png";